import types from "./types";
import userTypes from "store/users/types";
import { updateObject } from "utils";

const initialState = {
    orgLoading: false,
    orgDirLoading: false,
    orgDirError: {},
    modelDir: {},
    codeLib: {},
};

export default (state = initialState, action) => {
    switch (action.type) {
        // Fresh user data resets org state to just the member ids, so consumers refetch `details`.
        case userTypes.GET_USER_DATA:
            return {
                orgLoading: state.orgLoading,
                // the shared tree is kept: it is refetched on its own, not as part of `details`
                orgDirLoading: state.orgDirLoading,
                orgDirError: state.orgDirError,
                ...(state.modelDir ? { modelDir: state.modelDir } : {}),
                ...(state.codeLib ? { codeLib: state.codeLib } : {}),
                ...(action.userData?.organization ? { memberOrgIds: action.userData.organization } : {}),
            };
        case types.GET_USER_ORG:
            return userOrganization(state, action);
        case types.TOGGLE_ORG_LOADING:
            return updateObject(state, { orgLoading: action.orgLoading });
        case types.GET_ORG_DIR:
            // keyed by organization: a member of several must not have one tree overwrite another
            return updateObject(state, {
                modelDir: {
                    ...(state.modelDir || {}),
                    [action.orgId]: {
                        folders: action.modelDir?.folders || {},
                        models: action.modelDir?.models || {},
                    },
                },
            });
        case types.TOGGLE_ORG_DIR_LOADING:
            return updateObject(state, { orgDirLoading: action.orgDirLoading });
        case types.GET_ORG_CODE_LIB:
            return updateObject(state, {
                codeLib: { ...(state.codeLib || {}), [action.orgId]: action.codeLib },
            });
        case types.SET_ORG_CODE:
            return updateObject(state, {
                codeLib: {
                    ...(state.codeLib || {}),
                    [action.orgId]: { ...(state.codeLib?.[action.orgId] || {}), [action.codeRef]: action.code },
                },
            });
        case types.DELETE_ORG_CODE:
            return updateObject(state, {
                codeLib: {
                    ...(state.codeLib || {}),
                    [action.orgId]: Object.fromEntries(
                        Object.entries(state.codeLib?.[action.orgId] || {}).filter(([ref]) => ref !== action.codeRef)
                    ),
                },
            });
        case types.SET_ORG_DIR_ERROR:
            return updateObject(state, {
                orgDirError: { ...(state.orgDirError || {}), [action.orgId]: action.orgDirError },
            });
        case types.UPDATE_ORGANIZATION_SUCCESS:
            return {
                ...state,
                details: {
                    ...state.details,
                    [action.payload.orgId]: action.payload.organizationData,
                },
            };
        case types.UPDATE_ORGANIZATION_CHBA_WORKBOOK_TEMPLATE_SUCCESS:
            return {
                ...state,
                details: {
                    ...state.details,
                    [action.payload.orgId]: {
                        ...(state.details?.[action.payload.orgId] || {}),
                        templates: {
                            ...(state.details?.[action.payload.orgId]?.templates || {}),
                            chbaWorkbook: action.payload?.chbaWorkbookTemplates || {},
                        },
                    },
                },
            };
        default:
            return state;
    }
};

const userOrganization = (state, action) =>
    updateObject(state, {
        details: {
            ...(state.details || {}),
            [action.orgId]: action.organizationData,
        },
    });
